<template>
  <b-row>
    <!-- left align -->
    <b-col
        md="6"
        lg="4"
    >
      <b-card
          no-body
          class="box-shadow-6"
      >
        <div class="my-2">
          <b-card-title class="text-center">
            <b-badge
                v-if="isAuth"
                variant="success"
                class="mb-1"
            >
              Autenticado
            </b-badge>
            <h2 class="font-weight-bold">
              IAQFAZ
            </h2>
          </b-card-title>
          <div class="text-center mb-1">
            <logo-iaqfaz/>
          </div>
          <b-card-text class="font-small-3 mx-2">
            IAQFAZ - Integração e Automação com Qualidade para seu Fluxo de Trabalho.
          </b-card-text>
          <div class="d-flex justify-content-center">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                class="full-width mx-2"
                @click="openIntegrationModal()"
            >
              Gerenciar Workflows
            </b-button>
          </div>
        </div>
      </b-card>
    </b-col>

    <!-- Modal for Managing Workflows -->
    <b-modal
        v-model="showModal"
        title="Gerenciar Workflows IAQFAZ"
        size="lg"
        scrollable
        ok-only
        ok-title="Fechar"
        @hidden="resetForm"
    >
      <!-- Form for Create/Edit -->
      <b-form @submit.prevent="saveWorkflow">
        <b-form-group
            label="Nome"
            label-for="workflowName"
        >
          <b-form-input
              id="workflowName"
              v-model="form.nome"
              placeholder="Ex: ENROLLMENT"
              required
          />
        </b-form-group>

        <b-form-group
            label="Workflow ID"
            label-for="workflowId"
        >
          <b-form-input
              id="workflowId"
              v-model="form.workflow_id"
              placeholder="Ex: b6fed8ee-141e-40e0-9796-78b22784e797"
              required
          />
        </b-form-group>

        <b-form-group
            label="Descrição"
            label-for="workflowDescricao"
        >
          <b-form-textarea
              id="workflowDescricao"
              v-model="form.descricao"
              placeholder="Ex: Matrícula de curso"
              rows="2"
          />
        </b-form-group>

        <b-form-group class="mb-2">
          <b-form-checkbox
              v-model="form.ativo"
              name="workflowAtivo"
          >
            Ativo
          </b-form-checkbox>
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
              variant="outline-secondary"
              @click="resetForm"
              class="mr-1"
              size="sm"
          >
            Limpar
          </b-button>
          <b-button
              variant="primary"
              type="submit"
              size="sm"
          >
            {{ form.id ? 'Atualizar' : 'Salvar' }}
          </b-button>
        </div>
      </b-form>

      <hr class="my-3">

      <!-- Table of Workflows -->
      <div v-if="workflows.length > 0">
        <h6 class="mb-2">Workflows Registrados</h6>
        <b-table
            striped
            hover
            responsive
            :items="workflows"
            :fields="tableFields"
            small
            :stacked="isMobile"
        >
          <template #cell(ativo)="row">
            <b-badge :variant="row.item.ativo ? 'success' : 'secondary'" pill>
              {{ row.item.ativo ? 'Sim' : 'Não' }}
            </b-badge>
          </template>

          <template #cell(workflow_id)="row">
            <small class="text-muted" :title="row.item.workflow_id">
              {{ row.item.workflow_id.substring(0, 8) }}...
            </small>
          </template>

          <template #cell(actions)="row">
            <b-button
                size="sm"
                variant="flat-warning"
                @click="editWorkflow(row.item)"
                class="btn-icon mr-50"
            >
              <feather-icon icon="EditIcon" size="16" />
            </b-button>
            <b-button
                size="sm"
                variant="flat-danger"
                @click="deleteWorkflow(row.item.id)"
                class="btn-icon"
            >
              <feather-icon icon="TrashIcon" size="16" />
            </b-button>
          </template>
        </b-table>
      </div>

      <div v-else class="alert alert-info mb-0">
        <feather-icon icon="InfoIcon" size="18" class="mr-50" />
        <span>Nenhum workflow registrado</span>
      </div>
    </b-modal>
  </b-row>
</template>

<script>
import {
  BButton, BCard, BCardText, BCardTitle, BCol, BRow, BBadge, BModal, BForm,
  BFormGroup, BFormInput, BTable, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import LogoIaqfaz from '@/components/logos/LogoIaqfaz.vue'
import IaqfazIntegrationService from '@/views/apps/settings/integrations/iaqfaz/iaqfazIntegration.service'

const iaqfazService = new IaqfazIntegrationService()

export default {
  name: 'IaqfazIntegration',
  components: {
    LogoIaqfaz,
    BRow,
    BCol,
    BCard,
    BCardText,
    BButton,
    BCardTitle,
    BBadge,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BTable,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      isAuth: true,
      showModal: false,
      workflows: [],
      form: {
        id: null,
        nome: '',
        workflow_id: '',
        descricao: '',
        ativo: true,
      },
      tableFields: [
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'workflow_id', label: 'Workflow ID', sortable: true },
        { key: 'descricao', label: 'Descrição' },
        { key: 'ativo', label: 'Ativo', sortable: true },
        { key: 'actions', label: 'Ações' },
      ],
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 768
    },
  },
  async mounted() {
    await this.loadWorkflows()
  },
  methods: {
    async loadWorkflows() {
      try {
        this.workflows = await iaqfazService.getWorkflows()
      } catch (error) {
        console.error('Erro ao carregar workflows:', error)
        this.$bvToast.toast('Erro ao carregar workflows', {
          title: 'Erro',
          variant: 'danger',
        })
      }
    },
    openIntegrationModal() {
      this.resetForm()
      this.showModal = true
    },
    resetForm() {
      this.form = {
        id: null,
        nome: '',
        workflow_id: '',
        descricao: '',
        ativo: true,
      }
    },
    editWorkflow(workflow) {
      this.form = {
        id: workflow.id,
        nome: workflow.nome,
        workflow_id: workflow.workflow_id,
        descricao: workflow.descricao,
        ativo: workflow.ativo,
      }
    },
    async saveWorkflow() {
      try {
        if (this.form.id) {
          await iaqfazService.updateWorkflow(this.form.id, {
            nome: this.form.nome,
            workflow_id: this.form.workflow_id,
            descricao: this.form.descricao,
            ativo: this.form.ativo,
          })
          this.$bvToast.toast('Workflow atualizado com sucesso', {
            title: 'Sucesso',
            variant: 'success',
          })
        } else {
          await iaqfazService.createWorkflow({
            nome: this.form.nome,
            workflow_id: this.form.workflow_id,
            descricao: this.form.descricao,
            ativo: this.form.ativo,
          })
          this.$bvToast.toast('Workflow criado com sucesso', {
            title: 'Sucesso',
            variant: 'success',
          })
        }
        this.resetForm()
        await this.loadWorkflows()
        this.showModal = false
      } catch (error) {
        console.error('Erro ao salvar workflow:', error)
        this.$bvToast.toast('Erro ao salvar workflow', {
          title: 'Erro',
          variant: 'danger',
        })
      }
    },
    async deleteWorkflow(id) {
      if (!confirm('Tem certeza que deseja deletar este workflow?')) {
        return
      }

      try {
        await iaqfazService.deleteWorkflow(id)
        this.$bvToast.toast('Workflow deletado com sucesso', {
          title: 'Sucesso',
          variant: 'success',
        })
        await this.loadWorkflows()
      } catch (error) {
        console.error('Erro ao deletar workflow:', error)
        this.$bvToast.toast('Erro ao deletar workflow', {
          title: 'Erro',
          variant: 'danger',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
